export default __webpack_public_path__ + "static/media/library.42df2ddd.svg";